<template>
  <OverviewV2 v-if="useV2" />
  <OverviewLegacy v-else />
</template>

<script>
// Nouvel overview activé par VUE_APP_OVERVIEW_V2 (sandbox / local) ; la prod garde l'ancien pour le moment
const OVERVIEW_V2 = process.env.VUE_APP_OVERVIEW_V2 === 'true'

export default {
  name: 'overview',

  // Chargés à la demande : la version non utilisée n'est jamais téléchargée
  components: {
    OverviewV2: () => import('./OverviewV2.vue'),
    OverviewLegacy: () => import('./OverviewLegacy.vue')
  },

  data() {
    return {
      useV2: OVERVIEW_V2
    }
  }
}
</script>
